import type { SingleValue } from "react-select";
import t from "../../i18n";
import { colors } from "@ui/Theme";
import type { BaseOption } from "@ui/ReactSelect/useFormatOptionLabel";

export const multipleValue: BaseOption = {
  label: t("projects.modal.multiple_value"),
  value: "Multiple",
  color: colors.raw.titanium200,
};

export function getDefaultValue<T>(
  values: T[],
  key: keyof T,
  buildValues: (value: T) => BaseOption,
): SingleValue<BaseOption> {
  if (values.length === 0 || !values[0]) return null;
  const firstValue = values[0];
  const hasSameValue = values.filter(v => v[key] === firstValue[key]).length === values.length;
  if (hasSameValue) {
    return buildValues(firstValue);
  }
  return multipleValue;
}

export type ApiValue = {
  id: string | null;
  name: string;
};
